import de from '@/locales/de.json'
import en from '@/locales/en.json'
import es from '@/locales/es.json'
import fr from '@/locales/fr.json'
import it from '@/locales/it.json'

const locales = {
  de: { ...de },
  en: { ...en },
  es: { ...es },
  fr: { ...fr },
  it: { ...it }
}

export default locales
